goog.provide("shadow.js.shim.module$$tiptap$extension_text");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_text");
shadow.js.shim.module$$tiptap$extension_text = shadow.js.nativeProvides["@tiptap/extension-text"] = shadow$bridge("@tiptap/extension-text");
module$shadow_js_shim_module$$tiptap$extension_text.default = shadow.js.shim.module$$tiptap$extension_text;
